export const FETCH_SURVEYS_PENDING = "FETCH_SURVEYS_PENDING";
export const FETCH_SURVEYS_SUCCESS = "FETCH_SURVEYS_SUCCESS";
export const FETCH_SURVEYS_ERROR = "FETCH_SURVEYS_ERROR";
export const SET_REFRESH_TIMESTAMP = "SET_REFRESH_TIMESTAMP";
const initialState = {
  pending: false,
  surveys: {},
  error: null,
  timestamp: 0
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_SURVEYS_PENDING:
      return {
        ...state
        // Setting these causes SurveySection to constantly mount.

        // pending: true,
        // error: null
      };
    case FETCH_SURVEYS_SUCCESS:
      return {
        ...state,
        pending: false,
        surveys: action.surveys,
        error: null
      };
    case FETCH_SURVEYS_ERROR:
      return {
        ...state,
        pending: false,
        error: action.error
      };
    case SET_REFRESH_TIMESTAMP:
      return {
        ...state,
        timestamp: action.timestamp
      };
    default:
      return state;
  }
}

//Show a loading gif
export function fetchSurveysPending() {
  return {
    type: FETCH_SURVEYS_PENDING,
    surveys: {},
    error: null,
    pending: true
  };
}

//Show data
export function fetchSurveysSuccess(surveys) {
  return {
    type: FETCH_SURVEYS_SUCCESS,
    surveys: surveys,
    error: null,
    pending: false
  };
}

//Show error: ups sorry or something
export function fetchSurveysError(error) {
  return {
    type: FETCH_SURVEYS_ERROR,
    surveys: {},
    error: error,
    pending: false
  };
}

//Set the timestamp to the current epoch time
export function setRefreshTimestamp() {
  return {
    type: SET_REFRESH_TIMESTAMP,
    timestamp: Date.now()
  };
}

export const getSurveys = state => state.surveys;
export const getSurveysPending = state => state.pending;
export const getSurveysError = state => state.error;
export const getTimestamp = state => state.timestamp;
